import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleQuestionIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM12 4.98C8.2 4.98 5.06 8.14 5.06 11.96C5.06 15.78 8.2 18.94 12 18.94C15.8 18.94 18.94 15.78 18.94 11.96C18.94 8.14 15.8 4.98 12 4.98ZM12.2 7.48C13.86 7.48 15.06 8.56 15.06 9.92C15.06 11.18 14.18 12.04 12.88 12.4V13.3H11.12V11.54C12.76 11.38 13.3 10.76 13.28 10.02C13.26 9.42 12.76 9.06 12.18 9.06C11.54 9.06 10.92 9.54 10.92 10.36H9.18C9.14 8.64 10.52 7.48 12.2 7.48ZM12 16.32C11.44 16.32 10.94 15.82 10.94 15.26C10.94 14.7 11.44 14.2 12 14.2C12.56 14.2 13.06 14.7 13.06 15.26C13.06 15.82 12.56 16.32 12 16.32Z" />
    </SvgIcon>
  );
});
